export default "__VITE_ASSET__Bo2NOfY5__"